import React from 'react';
import './EmpowerBanner.css';

function EmpowerBanner({
  backgroundImage = '/images/creatives/landing-banner-bg.png',
  headingLine1 = 'A Comprehensive',
  headingLine2 = 'Program Designed',
  headingItalic = 'To Empower You',
  description = 'The Toronto Clinic Delivers More Than Healthcare. It Delivers A Strategy For Life. Rooted In Precision, Personalization, And Prevention, Our Membership Program Supports Your Health Journey From Every Angle.',
  btnText = 'Book A Consultation',
  btnIcon = '↗',
  onCtaClick
}) {
  return (
    <section className="ttc-empower-banner-wrapper position-relative py-5">
      
      <div 
        className="ttc-empower-bg-image" 
        style={{ backgroundImage: `url('${backgroundImage}')` }}
      />
      <div className="ttc-empower-bg-overlay" />

      <div className="container position-relative ttc-empower-content-layer py-lg-5">
        <div className="row align-items-end justify-content-between gy-4">
         
          <div className="col-12 col-lg-6">
            <h2 className="ttc-empower-heading text-white mb-0">
              {headingLine1 && <>{headingLine1} <br /></>}
              {headingLine2 && <>{headingLine2} <br /></>}
              {headingItalic && (
                <span className="ttc-empower-heading-italic">{headingItalic}</span>
              )}
            </h2>
          </div>

          <div className="col-12 col-lg-5 col-xl-5">
            {description && (
              <p className="ttc-empower-desc text-white-50 mb-4">
                {description}
              </p>
            )}
            <button 
              type="button" 
              onClick={onCtaClick} 
              className="btn ttc-empower-btn-primary d-inline-flex align-items-center gap-2"
            >
              <span>{btnText}</span>
              {btnIcon && <span className="ttc-empower-btn-icon">{btnIcon}</span>}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EmpowerBanner;